import Vue from "vue";
import Utils from "./utils";

Vue.use(Utils);
